// ** React Imports
import React, { Suspense } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

// ** Utils 

const PublicRoute = ({ children, route }) => {
  const { user } = useSelector((state) => ({ user: state.auth.user.user }), shallowEqual);
  if (route) {
    if (!user) {
      return <Navigate to='/auth/login' />;
    }
  }

  return <Suspense fallback={null}>{children}</Suspense>;
};

export default PublicRoute;
